import React, { memo } from 'react'
import SuggestLocation from 'transfix-ui/components/SuggestLocation'
import { IShipperRate, ILocation } from 'apps/rms/types/shipperRates'
import { capitalize } from 'utils/capitalize'

interface ILocationProps {
  value: RecursivePartial<IShipperRate>
  onChange(change: RecursivePartial<IShipperRate>): void
  type: 'pickup' | 'delivery'
  error?: string
}

export const Location = memo<ILocationProps>(({ error, onChange, type, value }) => {
  const setLocation = (location: ILocation) => {
    const { city, isoCountryCode, postalCode, state } = location
    onChange({ [type]: { city, stateCode: state, postalCode, isoCountryCode } })
  }

  const location = {
    city: value[type]?.city,
    state: value[type]?.stateCode,
    postalCode: value[type]?.postalCode,
  }

  return (
    <div className='col-md-6 col-xs-4'>
      <SuggestLocation
        label={`${capitalize(type)} Location`}
        placeholder='Enter city, state or ZIP'
        countries={['US', 'CA']}
        resultTypes={['City', 'PostalCode']}
        id={`modal-${type}`}
        value={location}
        dataTest={`modal-${type}`}
        onChange={setLocation}
        required
        errorMessage={error}
      />
    </div>
  )
})
